var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    transform: "translate(24) scale(-1 1)",
    fill: "white",
    stroke: "#9B51E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.808 9.232C7.03467 9.232 8.03733 8.74667 8.816 7.776L10.416 9.424C9.14667 10.8533 7.648 11.568 5.92 11.568C4.20267 11.568 2.784 11.024 1.664 9.936C0.554667 8.848 0 7.47733 0 5.824C0 4.16 0.565333 2.77333 1.696 1.664C2.83733 0.554667 4.22933 0 5.872 0C7.70667 0 9.24267 0.698667 10.48 2.096L8.928 3.856C8.13867 2.87467 7.15733 2.384 5.984 2.384C5.04533 2.384 4.24 2.69333 3.568 3.312C2.90667 3.92 2.576 4.74667 2.576 5.792C2.576 6.82667 2.89067 7.65867 3.52 8.288C4.14933 8.91733 4.912 9.232 5.808 9.232Z",
    transform: "translate(7 6)",
    fill: "#9B51E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampIcon);
export default __webpack_public_path__ + "static/media/camp-icon.0b7c2a8c6a43b9920e1e8f5890413437.svg";
export { ForwardRef as ReactComponent };